
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PulmonaryEmbolismSeverity',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PulmonaryEmbolismSeverity.vue